import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/audio-video.svg
 */
const IconAudioVideo: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4.5v12.578h1.065v-.967h1.6v.967h1.07v-.967h9.06c0 .899.394 1.76 1.095 2.396.7.636 1.65.993 2.64.993.99 0 1.941-.357 2.642-.993.7-.635 1.094-1.497 1.094-2.396V9.813H24V6.91h-6.402v5.954c-.034-.01-.062-.024-.096-.033a4.298 4.298 0 00-.438-.079V4.5h-1.063v.967h-1.599V4.5h-1.066v.967H3.74V4.5H2.671v.967h-1.6V4.5H0zm1.065 1.935h1.6v1.45h-1.6v-1.45zm2.67 0h9.595v4.154L11.16 8.62l-2.624 2.865L5.913 8.62l-2.169 1.966-.01-4.151zm10.662 0h1.598v1.45h-1.598v-1.45zm4.26 1.45h4.268v.968h-3.732v7.258c.002.476-.153.942-.443 1.339a2.62 2.62 0 01-1.19.89c-.327.125-.679.187-1.034.184a2.872 2.872 0 01-1.264-.284 2.583 2.583 0 01-.964-.796 2.212 2.212 0 01-.227-2.283c.27-.577.777-1.037 1.414-1.281a2.892 2.892 0 011.386-.162 3.004 3.004 0 01.668.16c.108.041.214.089.316.143l.806.417-.004-6.553zm-17.594.968h1.6v1.45h-1.6v-1.45zm13.326 0h1.599v1.452h-1.6V8.853zm-8.569 1.2l2.703 2.943 2.701-2.943 2.098 1.905v2.415c-.09.135-.17.275-.24.419-.051.114-.096.233-.135.352H3.728v-3.186l2.092-1.905zM1.057 11.27h1.6v1.454h-1.6v-1.454zm13.326 0h1.599v1.453h-1.6V11.27zm-13.326 2.42h1.6v1.45h-1.6v-1.45z"
      fill="currentColor"
    />
  </svg>
);

export default IconAudioVideo;
